let activeViewedBonusId = null;

export const rememberActiveBonusView = bonusId => {
  activeViewedBonusId = bonusId == null || bonusId === '' ? null : String(bonusId);
};

export const clearActiveBonusView = () => {
  activeViewedBonusId = null;
};

export const isActiveBonusView = bonusId =>
  activeViewedBonusId !== null && activeViewedBonusId === String(bonusId);
